import React, { useMemo } from "react";
import { useNodeAttrs } from "./../../_shared/use-node-attrs";
import { htmlConverter } from "./../html-converter";
import { HtmlViewer } from "../viewer/html-viewer";
const Html = ({ settings, node }) => {
  const { patchPmNodeAttrs, pmNodeAttrs } = useNodeAttrs(node.attrs.id, "HTML");
  const onIframeHeightChange = (height) => {
    patchPmNodeAttrs?.({
      ...pmNodeAttrs,
      containerData: { ...pmNodeAttrs.containerData, height: { custom: `${height}` } },
      iframeHeight: height
    });
  };
  const ricosNode = useMemo(() => htmlConverter.fromPm.convert(node.toJSON()), [node]);
  return /* @__PURE__ */ React.createElement(
    HtmlViewer,
    {
      htmlData: ricosNode?.htmlData,
      settings,
      onIframeHeightChange
    }
  );
};
export {
  Html
};
//# sourceMappingURL=component.js.map
